var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3643",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3643",
    transform: "translate(-13290 274.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_18021",
    "data-name": "\\u9577\\u65B9\\u5F62 18021",
    width: 20,
    height: 20,
    transform: "translate(13290 -274.173)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3639",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3639",
    transform: "translate(13292.022 -271.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_291",
    "data-name": "\\u30D1\\u30B9 291",
    d: "M-86.74,2.55a5.141,5.141,0,0,0-5.135,5.135A5.141,5.141,0,0,0-86.74,12.82,5.141,5.141,0,0,0-81.6,7.685,5.141,5.141,0,0,0-86.74,2.55Zm0,8.684a3.553,3.553,0,0,1-3.549-3.549A3.553,3.553,0,0,1-86.74,4.136a3.554,3.554,0,0,1,3.549,3.549A3.553,3.553,0,0,1-86.74,11.234Z",
    transform: "translate(91.875 -2.55)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_18002",
    "data-name": "\\u9577\\u65B9\\u5F62 18002",
    width: 1.586,
    height: 7.29,
    transform: "translate(9.313 10.434) rotate(-45)",
    fill: "#000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f2d48744979b4048ed2905d4c5f99477.svg";
export { ForwardRef as ReactComponent };